import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionRemoveCardAssigneesCodes = {
  AutomationV2ExecutionActionRemoveCardAssigneesFailedToRemoveAssignee: {
    code: 'automation-v2-execution-action/remove-card-assignees-failed-to-remove-assignee',
    explanation: `Falha ao remover atribuição de usuário.

**Causas comuns:**
- Usuário não estava atribuído ao card
- Erro de permissão

**Como diagnosticar:**
Verifique se o usuário realmente estava atribuído no momento da execução.`,
    localizations: {},
    message: 'Houve um erro ao tentar remover o responsável do card.',
    supportingDocs: [
      {
        name: 'Ação de Remover Responsáveis do Card',
        path: '/wiki/docs/automations/actions/remove-card-assignee',
      },
      {
        name: 'Gerenciamento de Responsáveis',
        path: '/wiki/docs/cards/tabs/general#responsáveis',
      },
    ],
  },
  AutomationV2ExecutionActionRemoveCardAssigneesMissingCardId: {
    code: 'automation-v2-execution-action/remove-card-assignees-missing-card-id',
    explanation: `ID do card é obrigatório no contexto da ação. O id do card é automaticamente passado pelo gatilho ou por ações anteriores.

**Causas comuns:**
- Variável cardId não resolvida
- Caso o valor do cardId seja mapeado manualmente, pode ter sido digitado incorretamente.
- Caso o valor do cardId não tenha sido mapeado, o \`context.card.id\` não está disponível.

**Como resolver:**
Corrija o mapeamento do ID do card.`,
    localizations: {},
    message:
      'Não foi possível remover o responsável do card porque o ID do card está faltando. Verifique se o card existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Remover Responsáveis do Card',
        path: '/wiki/docs/automations/actions/remove-card-assignee',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
  AutomationV2ExecutionActionRemoveCardAssigneesNoAssigneesProvided: {
    code: 'automation-v2-execution-action/remove-card-assignees-no-assignees-provided',
    explanation: `Lista de responsáveis vazia.

**Causas comuns:**
- Nenhuma seleção feita na configuração
- Variável dinâmica vazia

**Como resolver:**
Indique quais usuários devem ser removidos.`,
    localizations: {},
    message: 'Nenhum responsável foi fornecido para remover do card.',
    supportingDocs: [
      {
        name: 'Ação de Remover Responsáveis do Card',
        path: '/wiki/docs/automations/actions/remove-card-assignee',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
